<template>
  <CRow class="py-5 mt-4">
    <CCol xs="12" sm="12">
      <div>
        <h2 class="titlePage font-weight-bold text-capitalize mb-4">
          {{ $t('planSubscription.invoice.header') }}
        </h2>
      </div>
    </CCol>
    <!-- <CCol sm="12" v-if="loading">
      <div class="text-center py-5">
        <LoadingSpinner />
      </div>
    </CCol> -->
    <CCol xs="12" sm="12">
      <CCard>
        <CCardBody>
          <div class="mb-5">
            <CRow>
              <CCol md="4">
                <!-- {{ $t('planSubscription.invoice.daysSearch') }}
                <input v-model="lastDays" type="number" style="width: 100px" max="90" min="1" @input="changeDays()" /> -->
                <label class="label-custom required">{{ $t('usage-report.select.time-period.label') }}</label>
                <form @submit.prevent>
                  <v-date-picker
                    v-model="timePeriodRange"
                    color="purple"
                    mode="range"
                    timezone="UTC"
                    :locale="lang"
                    :min-date="timePeriodMinDate"
                    :max-date="new Date()"
                    is-required
                    is-range
                    addInputClasses="newInput"
                    class="select"
                    @input="filterChange"
                  >
                    <template v-slot="{ inputValue, inputEvents, showPopover, hidePopover }">
                      <CInput
                        :value="rangeFormatted"
                        class="dateInputCustom newInput px-0 text-left inputAppendCustom inputAppendCustom--transparent"
                        add-input-classes="pr-0"
                        v-on="inputEvents"
                        readonly
                        style="min-width: 260px; background-color: white"
                        @mouseover="showPopover"
                        @mouseleave="hidePopover"
                      >
                        <template #append-content>
                          <span @click="clearRange" class="pr-none">
                            <CIcon
                              v-if="inputValue"
                              style="cursor: pointer"
                              class="btn-value mt-2 text-center"
                              name="cilXCircle"
                              size="custom-size"
                              :height="23"
                              viewBox="0 0 32 32"
                            />
                          </span>
                        </template>
                      </CInput>
                    </template>
                  </v-date-picker>
                </form>
              </CCol>
            </CRow>
          </div>
          <div class="text-center py-5" v-if="loading">
            <LoadingSpinner />
          </div>
          <div v-if="!loading && registersSortedByDateAsc.length > 0">
            <SenditTable
              :headers="headers"
              :registers="registersSortedByDateAsc"
              :loading="loading"
              :itemsPerPage="itemsPerPage"
              :currentPage="currentPage"
              :totalPages="totalPages"
              :expandText="expandText"
              :expandHeaderText="$t('planSubscription.invoice.table.header.description')"
              pagination
              translateHeader
              expandable
              :searchTime="1500"
              @updatePage="atualizandoPage"
            >
              <template v-slot:paymentMethod="props">
                <td v-if="props.item.paymentMethod">
                  <CIcon :name="props.item.paymentMethod.brand" size="custom-size" :height="25" viewBox="0 0 32 32" />
                  •••• {{ props.item.paymentMethod.last4 }}
                </td>
              </template>

              <template #paymentStatus="{ item }">
                <td class="text-bolder" :class="getStatusCSSClass(item.paymentStatus)" style="min-width: 120px">
                  {{ getStatusTranslate(item.paymentStatus) }}
                </td>
              </template>

              <template #paymentDate="{ item }">
                <td>
                  {{ formatDate(item.paymentDate) }}
                </td>
              </template>

              <template #price="{ item }">
                <td>{{ formatPrices(item.price, 'code') }}</td>
              </template>

              <template #viewInvoice>
                <td>
                  <CIcon name="invoices" size="custom-size" :height="20" viewBox="0 0 32 32" />
                </td>
              </template>

              <template #expanded-area="{ item }">
                <h6 class="mb-3">{{ $t('planSubscription.invoice.table.header.description') }}</h6>

                <CDataTable :items="item.descritionData" :header="false" border addTableClasses="table-border">
                  <template #column="{ item }">
                    <td class="description-column px-4">{{ $t(item.column) }}</td>
                  </template>
                  <template #value="{ item }">
                    <td v-if="item.column == 'invoices.list.table.headers.id'" class="px-4 text-bolder">{{ item.value }}</td>
                    <td v-if="item.column == 'invoices.list.table.headers.status'" class="px-4 text-bolder">
                      <span :class="getStatusCSSClass(item.value)">{{ getStatusTranslate(item.value) }}</span>
                    </td>
                    <td v-if="item.column == 'invoices.list.table.headers.paymentDate'" class="px-4 text-value">{{ formatDate(item.value) }}</td>
                    <td v-if="item.column == 'invoices.list.table.headers.price'" class="px-4 text-value">{{ formatPrices(item.value, 'code') }}</td>
                    <td v-if="item.column == 'invoices.list.table.headers.subscriptions'" class="px-4 text-bolder">
                      <CRow v-for="(subscrition, index) in item.value" :key="index" class="mb-2">
                        <CCol>
                          {{ subscrition.description || '' }}
                        </CCol>
                        <CCol class="text-right"> {{ formatPrices(subscrition.price) }}</CCol>
                      </CRow>
                    </td>
                    <td v-if="item.column == 'invoices.list.table.headers.paymentMethod'" class="px-4 text-value">
                      <CIcon v-if="item.value" :name="item.value.brand" size="custom-size" :height="25" viewBox="0 0 32 32" />
                      •••• {{ item.value ? item.value.last4 : '' }}
                    </td>
                    <td v-if="item.column == 'invoices.list.table.headers.viewInvoice'" class="px-4 text-value">
                      <CIcon name="invoices" size="custom-size" :height="20" viewBox="0 0 32 32" />
                    </td>
                  </template>
                </CDataTable>
              </template>

              <template #footer-left>
                <div class="d-flex flex-column justify-content-center">
                  <p class="m-0">
                    <!-- <CIcon name="recover" size="custom-size" class="mr-3" :height="25" viewBox="0 0 32 32" /> -->
                    {{ $t('transational.logs.table.text.last90') }}
                  </p>
                </div>
              </template>
            </SenditTable>
          </div>
          <div v-if="registersSortedByDateAsc.length == 0 && !loading">
            <CCol xs="12" sm="6" class="offset-sm-3 text-center emptyCard d-flex flex-column content-center justify-content-center">
              <div>
                <figure class="mb-5">
                  <img src="@/assets/svg/NoContent.svg" alt="" />
                </figure>
                <h3 class="mb-3">
                  {{ $t('invoices.list.table.empty.title') }}
                </h3>
                <p class="px-5 text-gray-700">
                  {{ $t('invoices.list.table.empty.description') }}
                </p>
              </div>
            </CCol>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
    <!-- <CCol xs="12" sm="12" v-if="registersSortedByDateAsc.length == 0 && !loading">
      <CCard>
        <CCardBody>
          <CCol xs="12" sm="6" class="offset-sm-3 text-center emptyCard d-flex flex-column content-center justify-content-center">
            <div>
              <figure class="mb-5">
                <img src="@/assets/svg/NoContent.svg" alt="" />
              </figure>
              <h3 class="mb-3">
                {{ $t('invoices.list.table.empty.title') }}
              </h3>
              <p class="px-5 text-gray-700">
                {{ $t('invoices.list.table.empty.description') }}
              </p>
            </div>
          </CCol>
        </CCardBody>
      </CCard>
    </CCol> -->
  </CRow>
</template>

<script>
import SenditTable from '@/components/table/SenditTable.vue'
import { dateTimeFormatString, getUserDateFormat } from '@/utils/dateUtil'
import services from '@/services.js'
import { currencyFormat } from '@/utils/numbersFormatUtil'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

const paymentStatusEnum = {
  1: 'PROCESSING',
  2: 'SUCCESS',
  3: 'ERROR_1',
  4: 'ERROR_2',
}

const headerLabel = [
  { key: 'id', label: 'invoices.list.table.headers.id' },
  { key: 'paymentStatus', label: 'invoices.list.table.headers.status' },
  { key: 'paymentDate', label: 'invoices.list.table.headers.paymentDate' },
  { key: 'price', label: 'invoices.list.table.headers.price' },
  { key: 'paymentMethod', label: 'invoices.list.table.headers.paymentMethod' },
  { key: 'viewInvoice', label: 'invoices.list.table.headers.viewInvoice' },
  // {
  //   key: 'showDetails',
  //   label: '',
  //   _classes: 'hidde',
  //   _style: 'width:150px',
  // },
]

// const mockList = [
//   {
//     id: '1234-1234-1234-1234',
//     paymentStatus: 1,
//     paymentDate: new Date().toLocaleDateString(),
//     price: 34.9,
//     paymentMethod: {
//       last4: 4444,
//       brand: 'visa',
//     },
//     subscriptions: [
//       {
//         description: 'Buy pack 50 Email',
//         price: 10.0,
//       },
//     ],
//   },
//   {
//     id: '1234-1234-1234-1234',
//     paymentStatus: 2,
//     paymentDate: new Date().toLocaleDateString(),
//     price: 50.9,
//     paymentMethod: {
//       last4: 4444,
//       brand: 'mastercard',
//     },
//     subscriptions: [
//       {
//         description: 'Buy pack 1000 SMS',
//         price: 15.0,
//       },
//       {
//         description: 'Buy pack 50 Email',
//         price: 10.0,
//       },
//       {
//         description: 'Buy pack 50 Email',
//         price: 10.0,
//       },
//     ],
//   },
// ]

export default {
  components: {
    SenditTable,
    LoadingSpinner,
  },
  data() {
    return {
      registers: [],
      lastDays: 90,
      headers: headerLabel,
      itemsPerPage: 10,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      timeoutDate: null,
      loading: false,
      timePeriodRange: {
        start: null,
        end: null,
      },
      expandText: [this.$t('planSubscription.invoice.table.column.expand'), this.$t('planSubscription.invoice.table.column.collapse')],
      selectedItems: [],
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    filterChange() {
      console.log('teste ', this.timePeriodRange)

      this.getData()
    },
    clearRange() {
      // const currentDate = new Date()

      // const startDate = new Date(currentDate)
      // startDate.setDate(currentDate.getDate() - 30)

      this.timePeriodRange = {
        start: null,
        end: null,
      }
      this.getData()
    },
    changeDays() {
      if (this.timeoutDate) clearTimeout(this.timeoutDate)

      this.timeoutDate = setTimeout(() => {
        this.currentPage = 1
        this.getData()
      }, 1500)
    },
    getStatusTranslate(status) {
      return this.$t(`invoices.list.table.status.${paymentStatusEnum[status]}`) ?? 'unknow'
    },
    getStatusCSSClass(status) {
      switch (status) {
        case 1:
          return 'status-processing'
        case 2:
          return 'status-success'
        case 3:
        case 4:
          return 'status-error'
        default:
          return 'status-default'
      }
    },
    atualizandoPage(currentPage) {
      this.currentPage = currentPage
      this.getData()
    },
    getData() {
      this.loading = true
      let organizationId = this.$route.params.organizationId

      let params = {
        page: this.currentPage - 1,
        count: this.itemsPerPage,
        beginDateTime: this.timePeriodRange.start?.toISOString().split('T')[0],
        endDateTime: this.timePeriodRange.end?.toISOString().split('T')[0],
      }

      services
        .getInvoices(organizationId, params)
        .then((res) => {
          this.registers = res.data.data.invoices ?? []
          this.itemsPerPage = res.data.data.pagination.currentCount
          this.totalPages = res.data.data.pagination.totalPages
          this.totalRecords = res.data.data.pagination.totalRecords
          this.processDetailData()
        })
        .catch((error) => {
          console.log(error)
          this.messages.push({
            status: 'danger',
            text: error.response.data.message || '',
          })
        })
        .finally(() => (this.loading = false))

      // Para testar utilizando dados mock
      // setTimeout(() => {
      //   this.registers = mockList.reverse()
      //   this.loading = false
      //   this.processDetailData()
      // }, 2000)
    },

    formatPrices(price) {
      return currencyFormat(price)
    },

    formatDate(date) {
      return dateTimeFormatString(date)
    },

    processDetailData() {
      if (Array.isArray(this.registersSortedByDateAsc)) {
        this.registersSortedByDateAsc.forEach((elm) => {
          elm.descritionData = [
            { column: 'invoices.list.table.headers.id', value: elm.id },
            { column: 'invoices.list.table.headers.status', value: elm.paymentStatus },
            { column: 'invoices.list.table.headers.paymentDate', value: elm.paymentDate },
            { column: 'invoices.list.table.headers.price', value: elm.price },
            { column: 'invoices.list.table.headers.subscriptions', value: elm.subscriptions },
            { column: 'invoices.list.table.headers.paymentMethod', value: elm.paymentMethod },
            { column: 'invoices.list.table.headers.viewInvoice', value: '' },
          ]
        })
      }
    },

    selecionarLinha(linha) {
      this.selectedItems = linha
    },
    opt(data) {
      return dateTimeFormatString(data)
    },
  },

  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
    registersSortedByDateAsc() {
      return this.registers.sort((a, b) => new Date(b.paymentDate) - new Date(a.paymentDate))
    },
    hasRange() {
      return Boolean(this.timePeriodRange && this.timePeriodRange.start && this.timePeriodRange.end)
    },
    rangeFormatted() {
      if (!this.hasRange) return null

      const userDateTimeFormat = getUserDateFormat(this.$store.state.auth.user.dateTimeFormat)

      const formattedStart = DateTime.fromJSDate(this.timePeriodRange.start).setZone('UTC').toFormat(userDateTimeFormat.split(' ')[0])
      const formattedEnd = DateTime.fromJSDate(this.timePeriodRange.end).setZone('UTC').toFormat(userDateTimeFormat.split(' ')[0])

      return `${formattedStart} - ${formattedEnd}`
    },
    timePeriodMinDate() {
      const minDate = new Date()
      minDate.setFullYear(minDate.getFullYear() - 1)
      minDate.setDate(minDate.getDate() + 1)
      return minDate
    },
  },
}
</script>

<style lang="scss" scope>
.status-default {
  color: $gray-400;
}

.status-processing {
  color: $warning;
}

.status-success {
  color: $success;
}

.status-error {
  color: $error;
}

.emptyCard {
  height: 50vh;
}

.table-border {
  border-radius: 10px !important;
}

.table-border td {
  padding-top: 0.9rem !important;
  padding-bottom: 0.9rem !important;
}

.description-column {
  background-color: $gray-100;
  width: 300px;
  font-weight: 700;
}

.text-bolder {
  font-weight: 700;
}

.text-value {
  font-weight: 600;
}

.dateInputCustom .form-control[readonly] {
  background-color: white !important;
}
</style>
